import {graphql} from '../../../__generated__';

export const QUERY_SELECT_USERS = graphql(`
    query selectUsers (
        $filters: UsersPermissionsUserFiltersInput, $pagination: PaginationArg = {}, $sort: [String] = []
    ) {
        usersPermissionsUsers(filters: $filters, pagination: $pagination, sort: $sort) {
            documentId
            firstName
            lastName
            middleName
        }
    }
`);

export const QUERY_USERS = graphql(`
    query users (
        $filters: UsersPermissionsUserFiltersInput, $pagination: PaginationArg = {}, $sort: [String] = []
    ) {
        usersPermissionsUsers(filters: $filters, pagination: $pagination, sort: $sort) {
            documentId
            username
            email
            firstName
            lastName
            middleName
            blocked
            role {
                documentId
                name
            }
            clients {
                documentId
                firstName
                lastName
            }
        }
    }
`);

export const QUERY_USER = graphql(`
    query user ($documentId: ID!) {
        usersPermissionsUser(documentId: $documentId) {
            documentId
            username
            email
            firstName
            lastName
            middleName
            blocked
            role {
                documentId
                name
            }
            clients {
                documentId
                firstName
                lastName
            }
        }
    }
`);

export const UPDATE_USER = graphql(`
    mutation updateUser ($id: ID!, $data: UsersPermissionsUserInput!) {
        updateUsersPermissionsUser(id: $id, data: $data) {
            data {
                documentId
            }
        }
    }
`);

export const CREATE_USER = graphql(`
    mutation createUser ($data: UsersPermissionsUserInput!) {
        createUsersPermissionsUser(data: $data) {
            data {
                documentId
            }
        }
    }
`);

export const QUERY_USER_NOTIFICATIONS = graphql(`
    query userNotifications ($userId: ID!, $pagination: PaginationArg = {}) {
        notifications_connection(
            filters: {user: {documentId: {eq: $userId}}}, pagination: $pagination, sort: ["createdAt:desc"]
        ) {
            nodes {
                documentId
                createdAt
                updatedAt
                template
                state
                errorMessage
                payload
            }
            pageInfo {
                page
                pageSize
                total
            }
        }
    }
`);

export const QUERY_IIKO_EMAIL = graphql(`
    query iikoEmail ($phone: String!) {
        iikoEmail(phone: $phone)
    }
`);

export const CHECK_LOGIN = graphql(`
    query checkLogin ($username: String!) {
        checkLogin(username: $username)
    }
`);
